export const formatPlanString = (interval) => {
	if (interval) {
		return `${interval === 'month' ? 'monthly' : 'annual'} plan`;
	} else {
		return 'plan';
	}
};
